import React from "react";
import { Fab } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ActionBar from "@search/ActionBar";
import locale from "@bonliva-crm/locale";
import { store } from "@store";
import { SortOption } from "@search/SortOptions";

type Props = {
  onNew: () => void;
  total: number;
  sortOptions?: SortOption[];
  onSortOption?: (v: SortOption) => void;
};

export function AccommodationSearchActionBar(props: Props) {
  return (
    <ActionBar
      actions={[
        <Fab
          key="new"
          color="primary"
          title={locale.New}
          onClick={props.onNew}
          size="small"
          disabled={!store().user.hasPermission("CanAddAccommodation")}
        >
          <Add />
        </Fab>
      ]}
      // onSortOption={props.onSortOption}
      // sortOptions={props.sortOptions}
      total={props.total}
      style={{ padding: "8px 16px" }}
    />
  );
}
